import { render, staticRenderFns } from "./CreateBagianLab.vue?vue&type=template&id=685cf0b1&scoped=true"
import script from "./CreateBagianLab.vue?vue&type=script&lang=js"
export * from "./CreateBagianLab.vue?vue&type=script&lang=js"
import style0 from "./CreateBagianLab.vue?vue&type=style&index=0&id=685cf0b1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "685cf0b1",
  null
  
)

export default component.exports